<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-ttl sigilNotInTOC" id="heading_id_2">CAST OF CHARACTERS</h1>
<p class="fm-body"><b class="calibre3">Florence Rubrick</b>, <i class="calibre2">Of Mount Moon</i></p>
<p class="fm-body"><b class="calibre3">Arthur Rubrick</b>, <i class="calibre2">Her husband</i></p>
<p class="fm-body"><b class="calibre3">Sammy Joseph</b>, <i class="calibre2">Wool buyer for Riven Brothers</i></p>
<p class="fm-body"><b class="calibre3">Alf</b>, <i class="calibre2">Storeman at Riven Brothers</i></p>
<p class="fm-body"><b class="calibre3">Roderick Alleyn</b>, <i class="calibre2">Chief Detective-Inspector, CID</i></p>
<p class="fm-body"><b class="calibre3">Fabian Losse</b>, <i class="calibre2">Nephew to Arthur Rubrick</i></p>
<p class="fm-body"><b class="calibre3">Douglas Grace</b>, <i class="calibre2">Nephew to Florence Rubrick</i></p>
<p class="fm-body"><b class="calibre3">Ursula Harme</b>, <i class="calibre2">Her niece</i></p>
<p class="fm-body"><b class="calibre3">Terence Lynne</b>, <i class="calibre2">Her secretary. Later gardener at Mount Moon</i></p>
<p class="fm-body"><b class="calibre3">Mrs Aceworthy</b>, <i class="calibre2">Housekeeper at Mount Moon</i></p>
<p class="fm-body"><b class="calibre3">Markins</b>, <i class="calibre2">Manservant at Mount Moon</i></p>
<p class="fm-body"><b class="calibre3">Tommy Johns</b>, <i class="calibre2">Working manager at Mount Moon</i></p>
<p class="fm-body"><b class="calibre3">Mrs Johns</b>, <i class="calibre2">His wife</i></p>
<p class="fm-body"><b class="calibre3">Cliff Johns</b>, <i class="calibre2">Their son</i></p>
<p class="fm-body"><b class="calibre3">Ben Wilson</b>, <i class="calibre2">Wool sorter</i></p>
<p class="fm-body"><b class="calibre3">Jack Merrywether</b>, <i class="calibre2">Presser</i></p>
<p class="fm-body"><b class="calibre3">Albert Black</b>, <i class="calibre2">Rouseabout</i></p>
<p class="fm-body"><b class="calibre3">Percy Gould</b>, <i class="calibre2">Shearers’ cook</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?e9a98972